module.exports = __webpack_public_path__ + "img/julie-ertz.fef2359d.png";